<template>
  <div class="payMethods">
    <div class="scan_code_div" v-if="!$isAlipay">
      <div class="scan_code">
        <img class='image' :src="require('@/../public/static/pay/wechat.svg')" fit="fill"/>
      </div>
      <el-button size="small"
                 :disabled="payDisabled"
                 @click="payClick(WX, name, type)"
                 type="text">
        微信支付
      </el-button>
    </div>
    <div class="scan_code_div" v-if="!$isWeixin">
      <div class="scan_code">
        <img class='image' :src="require('@/../public/static/pay/alipay.svg')" fit="fill"/>
      </div>
      <el-button size="small"
                 :disabled="payDisabled"
                 @click="payClick(ALIPAY, name, type)"
                 type="text">
        支付宝支付
      </el-button>
    </div>
	<!--
    <div class="scan_code_div" v-if="!balanceDisabled">
      <div class="scan_code">
        <img :src="require('@/static/pay/wallet.svg')" fit="fill"/>
      </div>
      <el-button size="small"
                 type="text"
                 :disabled="payDisabled"
                 @click="payClick(BALANCE, name, type)">
        云豆支付
        <el-tooltip>
          <template #content>
            <span>点此
              <a href="javascript: void(0)"
                 style="color: #909090; text-decoration: none;"
                 @click="toRecharge">
                充值云豆
              </a>，享受优惠</span>
          </template>
          <span class="saleTag">优惠</span>
        </el-tooltip>
      </el-button>
    </div>
	-->
    <div style="clear: both;"></div>
  </div>

</template>

<script>
export default {
  name: "OrderPayMethods",
  props: {
    name: String,
    type: Number,
    payDisabled: Boolean,
    balanceDisabled: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      BALANCE: 0,
      WX: 1,
      ALIPAY: 2,
    }
  },
  methods: {
    payClick(payMethod, buyMethod, type) {
      this.$emit('pay-click', payMethod, buyMethod, type)
    },
    toRecharge() {
      this.$router.push({path: this.$isMobile ? '/index/mPersonCenter/myWallet' : '/index/pcPersonCenter/myWallet'})
    }
  },

}
</script>

<style lang="less">
  .payMethods {
    .scan_code_div {
      float: right;
      display: inline-block;
      height: 40px;
      margin-left: 20px;
      margin-top: 10px;
    }
	
	
	
    .scan_code_div .scan_code {
      float: left;
      margin: 7px 5px;
      width: 20px;
      height: 20px;
    }
	
	.image{
		width: 20px;
		height: 20px;
	}

    .scan_code_div button {
      padding: 0;
      line-height: 40px;
    }

    .scan_code_div .el-checkbox, .scan_code_div .el-checkbox__input, .scan_code_div .el-checkbox__label {
      line-height: 40px;
      height: 40px;
      display: inline-block;
      padding-left: 3px;
    }

    .scan_code_div .el-checkbox__input .el-checkbox__inner {
      margin: 11px 0;
    }

    .saleTag {
      display: inline-block;
      color: white;
      background-color: rgb(213, 44, 44);
      line-height: 14px;
      padding: 0 5px;
      font-size: 12px;
      border-radius: 5px;
    }

  }
</style>